(function(){
    console.log('产品详情 bulndle:init 事件监听器已加载');
    const svgIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.38452 5.96143H16.692L15.8971 16.692H3.17938L2.38452 5.96143Z" stroke="#171717" stroke-linejoin="round"/>
            <path d="M6.35889 7.55111V2.38452H12.7178V7.55111" stroke="#171717" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.75 11.3268H11.3269" stroke="#171717" stroke-linecap="round"/>
            <path d="M9.53833 9.53833L9.53833 13.1152" stroke="#171717" stroke-linecap="round"/>
            </svg>
            `;
        var oneTimer = null;
      document.addEventListener('bundle:init', function (e) {
        

       if(oneTimer) clearTimeout(oneTimer);
          oneTimer = setTimeout(()=>{
                    try{
                        //获取 primary-title 元素，更改其文本内容 为 Upsell 
                        // document.querySelector('.rebuy-widget.widget-type-dynamic-bundle .primary-title').textContent = 'Upsell';


                        document.querySelectorAll('.rebuy-widget.widget-type-dynamic-bundle .rebuy-bundle__actions').forEach((actionBox,index) => {
                            // 1️⃣ 插入 SVG 到按钮
                            const buttons = actionBox.querySelectorAll('.rebuy-bundle__actions-buttons');
                            buttons.forEach(button => {
                            button.insertAdjacentHTML('afterbegin', svgIcon);
                            });

                            // 2️⃣ 读取价格
                            const saleSpan = actionBox.querySelector('.rebuy-bundle__actions-price span.sale span:last-child');
                            const compareSpan = actionBox.querySelector('.rebuy-bundle__actions-price span.compare-at span:last-child');
                            console.log('销售价格元素:', saleSpan);
                            console.log('对比价格元素:', compareSpan);
                            if (saleSpan && compareSpan) {
                                const saleRaw = saleSpan.textContent.trim();
                                const compareRaw = compareSpan.textContent.trim();

                                // 提取货币符号（第一个非数字字符）
                                const currencySymbolMatch = compareRaw.match(/^[^\d]+/);
                                const currency = currencySymbolMatch ? currencySymbolMatch[0] : '';

                                // 提取纯数字
                                const sale = parseFloat(saleRaw.replace(/[^0-9.]/g, '')); 
                                const compare = parseFloat(compareRaw.replace(/[^0-9.]/g, ''));
                                // console.log('销售价格:', sale);
                                // console.log('对比价格:', compare);

                                if (!isNaN(sale) && !isNaN(compare) && compare > sale) {
                                    const discount = (compare - sale).toFixed(2);

                                    // 创建按钮
                                    const saveBtn = document.createElement('div');
                                    saveBtn.textContent = `SAVE -${currency}${discount}`;
                                    saveBtn.classList.add('save_price_button')

                                    console.log('创建 SAVE 按钮:', saveBtn);
                                    console.log('插入到:', actionBox.querySelector('.rebuy-bundle__actions-price'));
                                    // 插入当前 actionBox 下的 class  rebuy-bundle__actions-price 里
                                    actionBox.querySelector('.rebuy-bundle__actions-price').appendChild(saveBtn);
                                }
                            }
                            // index 偶数时，在当前 actionBox 插入 一句话： best sellers， 添加class 名 best_sellers_note
                           
                        });
                    }catch{
                    
                    }
        },2000)
    })
  //监听 bundle:cart:add 事件
        document.addEventListener('bundle:cart:add', function (e) {
           
            //更新购物车图标或执行其他操作
            //执行 cart:refresh 事件以刷新购物车
            document.dispatchEvent(new Event('cart:refresh'));
            //获取 aria-controls="cart-drawer" 的元素，执行点击事件以打开购物车抽屉
            const cartDrawerToggle = document.querySelector('a[aria-controls="cart-drawer"]');
            if (cartDrawerToggle) {
                cartDrawerToggle.click();
            }
        });
})();